import type {Mapper} from 'framework';
import type {AssistantProposal} from '../../domain/assistant-proposal';
import type {AssistantProposalDto} from '../dto/assistant.dto';

export class AssistantProposalDtoToAssistantProposalMapper implements Mapper<
  AssistantProposalDto,
  AssistantProposal
> {
  transform(dto: AssistantProposalDto): AssistantProposal {
    return {
      id: dto.id,
      kind: dto.kind,
      status: dto.status,
      payload: dto.payload,
      appliedEntityId: dto.appliedEntityId,
      decidedAt: dto.decidedAt,
      createdAt: dto.createdAt,
    };
  }
}
